// extracted by mini-css-extract-plugin
export default {"root":"CompactPersonGrid-module--root--b9927","profile":"CompactPersonGrid-module--profile--4ccdf"};